<template>
  <div :class="{'reaction-grade': true, 'reaction-container': true, 'reaction-empty': count == 0}">
    <div :class="{'reaction-show': true, 'reaction-editable': canReact}"
         :title="title"
         @click="startReacting">
      <base-icon name="tick"
                 size="small"
                 :class="{'caption-type': !myReaction, 'highlighted-icon': myReaction}" />
      <!-- N.B. use vue key attribute to prevent vue from reusing the wrong span element in Firefox https://vuejs.org/v2/api/#key -->
      <span v-if="!!avgRating"
            key="average"
            class="reaction-grade-value small-type">{{ avgRating + "/" + maxGrade }}</span>
      <span v-if="count > 0"
            key="count"
            class="reaction-grade-count small-type caption-type">{{ count }}</span>
      <span v-if="canReact && !myReaction"
            key="gradeButton"
            role="button"
            class="small-buttony-caption-type strong-type reaction-action"
            v-t>Grade</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BaseIcon from 'vuecomponents/base_icon'
import IntlMixin from 'vuemixins/intl_mixin'

export default {
  components: { BaseIcon },
  mixins: [IntlMixin],
  props: ['userId', 'isReactable', 'reactionIds', 'reactions', 'maxGrade'],
  computed: {
    ...mapState(['isPhone']),
    myReaction () {
      return this.reactionIds.filter((x) => this.reactions[x].user_id === this.userId)[0]
    },
    myRating () { return this.myReaction ? this.reactions[this.myReaction].value : 0 },
    canReact () { return this.isReactable },
    count () { return this.reactionIds.length },
    title () {
      if (this.count === 0) return this.__('Be the first one to grade this post')
      let title = `${this.__('Avg score')}: ${this.avgRating}`
      if (this.myRating) {
        title += ` • ${this.__('Your score')}: ${this.myRating}`
      }
      return title
    },
    $_sumRating () {
      let sumReducer = (sum, id) => sum + this.reactions[id].value
      return this.reactionIds.reduce(sumReducer, 0)
    },
    avgRating () {
      if (this.count === 0) return null
      return Math.ceil(this.$_sumRating / this.count)
    },
  },
  methods: {
    ...mapActions('snackbars', ['setSnackbar']),
    showReactionOffNotice () {
      const message = this.__('Reactions have been disabled by the admin.')
      this.setSnackbar({ message })
    },
    startReacting () {
      if (this.canReact) {
        this.$emit('edit')
      } else {
        this.showReactionOffNotice()
      }
    },
  },
}
</script>
